import './App.css';
import React from 'react';
import MyChat from './MyChat';
import PromptEdit from './PromptEdit'
import logo from './sokrates_logo4.png'
import {DropdownButton, Dropdown} from 'react-bootstrap'

function App() {
  const [module, setModule] = React.useState({
    title: "Module 0: Sokrates",
    category: "sokrates"
  })

  return (
    <div>
      <div style={{width: "100%", display: "flex"}}>
        <div style={{width: "20%"}}>
          <img src={logo} width="75%" alt='' style={{margin: "1.5% 4% 0"}} />
        </div>
      </div>
      {/* <DropdownButton variant="warning" style={{margin: "-1% 1.5%"}} id="dropdown-item-button" title={module.title}>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 0: Sokrates", category: "sokrates"})}>Module 0: Sokrates</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 1: Abortion & Euthenasia", category: "abortion"})}>Module 1: Abortion & Euthenasia</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 2: Academic & Ethical Theory", category: "theory"})}>Module 2: Academic & Ethical Theory</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 3: Animals, Adultery, & Lying", category: "animal"})}>Module 3: Animals, Adultery, & Lying</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 4: Ethical Tomfoolery & Manipulation", category: "manipulation"})}>Module 4: Ethical Tomfoolery & Manipulation</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 5: Ethical", category: "ethical"})}>Module 5: Ethical</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 6: Ethics", category: "ethic"})}>Module 6: Ethics</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 7: Moral Concepts", category: "moral"})}>Module 7: Moral Concepts</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 8: Moral Thought Experiments", category: "experiment"})}>Module 8: Moral Thought Experiments</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 9: Unethical Pain & Suffering", category: "unethical"})}>Module 9: Unethical Pain & Suffering</Dropdown.Item>
        <Dropdown.Item as="button" onClick={() => setModule({title: "Module 10: Score", category: "score"})}>Module 10: Score</Dropdown.Item> */}
        {/* <Dropdown.Item as="button" onClick={() => setModule({title: "Module 10: All", category: "all"})}>Module 10: All</Dropdown.Item> */}
      {/* </DropdownButton> */}
      {/* <h2 style={{marginTop: "1.5%", marginLeft: "1.5%"}}>{module.title}</h2>
      <div style={{width: "65%", marginLeft: "1.5%", marginTop: "1%"}}>
        <PromptEdit module={module.category} />
      </div> */}
      <MyChat module={module.category}/>
    </div>
  );
}

export default App;
